<script lang="ts">
export default { name: 'CommonSelect', inheritAttrs: false }
</script>

<script setup lang="ts">
defineProps(['modelValue', 'id', 'disabled', 'options'])
const emit = defineEmits(['update:modelValue'])

/** changeイベント発火時の処理 */
function onChange(e: Event) {
  emit('update:modelValue', JSON.parse((e.target as HTMLInputElement).value))
}
</script>

<template>
  <span v-bind="$attrs">
    <select
      :value="modelValue"
      class="appearance-none border border-gray-300 rounded-[4px] w-full sm:p-[12px] p-[10px]"
      @change="onChange"
    >
      <option value="" disabled selected style="display: none">選択してください</option>
      <option v-for="{ label, value } of options" :key="`${id}_${value}`" :value="JSON.stringify(value)">
        {{ label }}
      </option>
    </select>
  </span>
</template>
